import { getDeliveryInfo, getDeliveryPickup } from '~/selectors';
import useSelector from '~/store/useSelector';

export default function useShowDeliveryUnavailableBanner(): boolean {
  const { hasError, isLoaded } = useSelector(getDeliveryPickup);
  const canDeliver = Boolean(useSelector(getDeliveryInfo));

  return isLoaded && !hasError && !canDeliver;
}
